import { useLingui } from "@lingui/react/macro";
import { BellOff } from "lucide-react";
import { observer } from "mobx-react-lite";

import { Tooltip } from "../../../components/ui-kit/base/tooltip";
import { Thresholds, ThresholdsItem } from "./thresholds";

/**
 * The comorbidities that mute a default threshold. Deliberately plain text
 * rather than badges, which in this table read as data (see `Tags`), and in
 * the table's normal foreground like every other cell — colour here carries
 * exactly one meaning: the danger-coloured line with the bell icon is the
 * suppression that's active for this patient right now.
 */
export const SuppressionCell = observer(function SuppressionCell({
  model,
  item,
}: {
  model: Thresholds;
  item: ThresholdsItem;
}) {
  const { t } = useLingui();
  const suppressions = model.suppressions(item);
  if (suppressions.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col items-center gap-0.5">
      {suppressions.map(({ diagnosis, matchedValue }) => {
        const label = `${diagnosis.diagnosis_name}: ${diagnosis.suppressing_values.join(", ")}`;
        if (matchedValue === null) {
          return <span key={diagnosis.diagnosis_name}>{label}</span>;
        }
        return (
          <Tooltip
            key={diagnosis.diagnosis_name}
            content={t`Muted for this patient — active diagnosis "${diagnosis.diagnosis_name}" is "${matchedValue}".`}
            side="top"
          >
            <span className="text-danger-foreground flex cursor-help items-center gap-1 font-medium">
              <BellOff className="size-3 shrink-0" />
              {label}
            </span>
          </Tooltip>
        );
      })}
    </div>
  );
});
